const STARTED_FETCHING_COHORTS = 'STARTED_FETCHING_COHORTS';
const GOT_COHORTS = 'GOT_COHORTS';
const ERROR_FETCHING_COHORTS = 'ERROR_FETCHING_COHORTS';

export {
  STARTED_FETCHING_COHORTS,
  GOT_COHORTS,
  ERROR_FETCHING_COHORTS,
};
